import {Box, Grid, Typography} from "@mui/material"

import ReviewLineLink from "./visibleResult/ReviewLineLink"
import ReviewQrCode from "./visibleResult/ReviewQrCode"

interface ReviewResultLinkProps {
    visibleResult: boolean,
    shortLink: string,
}

const ReviewResultLink = (props: ReviewResultLinkProps) => {
    const {visibleResult,  shortLink} = props

    return (
        <Box hidden={visibleResult}>
            <Typography sx={{ pb: 2, pt: 2, fontSize: 25 }}>Результат: </Typography>
            <Box sx={{ display: 'flex' }} >
                <ReviewLineLink shortLink={shortLink} />
            </Box>
            <Box sx={{mt: 2}} hidden={visibleResult}>
                <ReviewQrCode qr={shortLink}/>
            </Box>
        </Box>

    )
}

export default ReviewResultLink;